import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock, unref as _unref, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "sfx-entity-reference__title text-h6" }
const _hoisted_2 = {
  key: 0,
  class: "text-body2"
}
const _hoisted_3 = {
  key: 1,
  class: "sfx-entity-reference__item text-h6"
}

import { Icons } from "src/util/enums/fontAwesomeIcons"
import { computed } from "vue"

//region Props and Emits

const iconSize = "20px"

//endregion

export default /*#__PURE__*/_defineComponent({
  __name: 'SfxEntityReference',
  props: {
  title: {
    type: String,
    required: true,
  },

  itemCount: {
    type: Number,
    default: undefined,
  },

  timeInformation: {
    type: String,
    default: undefined,
  },

  deadlinePassed: {
    type: Boolean,
    default: false,
  },

  icon: {
    type: String,
    default: undefined,
  },

  priorityLabel: {
    type: String,
    default: undefined,
  },

  iconColor: {
    type: String,
    default: "grey",
  },

  clickable: {
    type: Boolean,
    default: false,
  },
},
  emits: ["click"],
  setup(__props, { emit: __emit }) {

const props = __props

// QItem prevents this event when clickable is false
const emit = __emit

//endregion

//region Variables

const deadlineClass = computed(() => {
  return `sfx-entity-reference__deadline_${props.deadlinePassed ? "past" : "future"}`
})

const isHexColor = computed(() => props.iconColor?.includes("#"))
const iconStyle = computed(() => (isHexColor.value ? { color: props.iconColor } : undefined))
const iconColor = computed(() => (isHexColor.value ? undefined : props.iconColor))

return (_ctx: any,_cache: any) => {
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item = _resolveComponent("q-item")!
  const _directive_ripple = _resolveDirective("ripple")!

  return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
    clickable: props.clickable,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click'))),
    class: "sfx-entity-reference items-center text-navy-700"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("span", _hoisted_1, _toDisplayString(props.title), 1),
        (props.itemCount || props.itemCount === 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, " (" + _toDisplayString(props.itemCount) + ") ", 1))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_q_space),
      _renderSlot(_ctx.$slots, "timeInformation", {}, () => [
        (props.timeInformation)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(["sfx-entity-reference__item text-subtitle2", deadlineClass.value])
            }, _toDisplayString(props.timeInformation), 3))
          : _createCommentVNode("", true)
      ]),
      (props.icon)
        ? (_openBlock(), _createBlock(_component_q_icon, {
            key: 0,
            name: props.icon,
            class: "sfx-entity-reference__item",
            color: iconColor.value,
            style: _normalizeStyle(iconStyle.value),
            size: iconSize
          }, null, 8, ["name", "color", "style"]))
        : _createCommentVNode("", true),
      (props.priorityLabel)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
            _createElementVNode("b", null, _toDisplayString(props.priorityLabel), 1)
          ]))
        : _createCommentVNode("", true),
      (props.clickable)
        ? (_openBlock(), _createBlock(_component_q_icon, {
            key: 2,
            name: _unref(Icons).INTERNAL_LINK,
            class: "q-pl-xs",
            size: iconSize
          }, null, 8, ["name"]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["clickable"])), [
    [_directive_ripple]
  ])
}
}

})